import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalData } from '../../model/modal-data.model';
import { OlxCategory } from '../../modules/crm/power-olx-v2/interfaces/power-olx-v2.interface';
import { isLgMobile } from '../../helpers/utils';

@Component({
  selector: 'app-select-category',
  templateUrl: './select-category.component.html',
  styleUrl: './select-category.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SelectCategoryComponent implements OnInit {
  private categories!: OlxCategory[];
  protected categoriesTree: OlxCategory[][] = [];
  protected selectedCategories: OlxCategory[] = [];

  get currentLevel(): number {
    return this.categoriesTree.length - 1;
  }

  constructor(
    public dialogRef: MatDialogRef<SelectCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData<OlxCategory[]>,
  ) {
    this.categories = data.data || [];
  }

  ngOnInit(): void {
    this.buildTree();
  }

  private buildTree(): void {
    const root = this.categories.filter((c) => c.parent_id === 0).sort((a, b) => a.name.localeCompare(b.name));
    this.categoriesTree = [root];
  }

  protected onCategorySelect(level: number, category: OlxCategory): void {
    this.selectedCategories = this.selectedCategories.slice(0, level);
    this.selectedCategories[level] = category;

    this.categoriesTree = this.categoriesTree.slice(0, level + 1);

    if (!category.is_leaf) {
      const children = this.categories
        .filter((c) => c.parent_id === category.category_id)
        .sort((a, b) => a.name.localeCompare(b.name));
      this.categoriesTree.push(children);
    } else {
      this.selectLeafCategory(category.category_id);
    }
  }

  private selectLeafCategory(categoryId: number): void {
    this.dialogRef.close(categoryId);
  }

  protected goBack(): void {
    if (this.categoriesTree.length - 1 > 0) {
      this.categoriesTree.pop();
      this.selectedCategories.pop();
    }
  }

  protected readonly isLgMobile = isLgMobile;
}
